import React from "react";
import { Autocomplete, TextField, Chip } from "@mui/material";
import { FilterInputProps } from "./FilterInput.types";
import { FILTER_INPUT_HEIGHTS } from "../../DataTable.theme";

/**
 * Multi-select filter input component.
 */
export const MultiSelectFilter: React.FC<FilterInputProps> = ({
  value,
  onChange,
  density = "standard",
  options = [],
  placeholder = "Seleziona...",
}) => {
  return (
    <Autocomplete
      multiple
      size="small"
      options={options}
      getOptionLabel={(option) => option.label}
      value={
        (value as string[])?.map(
          (v) =>
            options.find((o) => o.value === v) || {
              value: v,
              label: v,
            },
        ) || []
      }
      onChange={(_, newValue) =>
        onChange(newValue.length > 0 ? newValue.map((v) => v.value) : null)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={!value ? placeholder : undefined}
          sx={{
            "& .MuiInputBase-root": {
              fontSize: density === "compact" ? "0.75rem" : "0.875rem",
              minHeight: FILTER_INPUT_HEIGHTS[density],
            },
          }}
        />
      )}
      renderValue={(tagValue, getItemProps) =>
        tagValue.map((option, index) => (
          <Chip
            {...getItemProps({ index })}
            key={option.value}
            label={option.label}
            size="small"
          />
        ))
      }
    />
  );
};
